import { Button, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
// import SaveProductButton from "./SaveProductButton";
import { useRecordContext } from "react-admin";
import CustomProductIntTextField from "../../unit/forms/CustomProductIntTextField";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function Timeline({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "timeline";
  const sectionTitle = "Timeline - Set deadline for key process milestones";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.timeline;
  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        expiration_days: data?.expiration_days || "15",
        max_onhold_days: data?.max_onhold_days || "15",
        underwriting_period_days: data?.underwriting_period_days || "7",
        loanoffer_expiration: data?.loanoffer_expiration || "5",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = (formData: any) => {
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FieldTitle title="Incomplete Application Removal" />
          </Grid>
          <Grid item xs={2}>
            <Controller
              name="expiration_days"
              control={control}
              //>0
              rules={{
                required: "Minimum amount is required", // 添加必填验证
                validate: (value) => {
                  return (
                    parseFloat(value) >= 15 || "Min amount must be at least 15"
                  );
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <CustomProductIntTextField
                  {...field}
                  small
                  error={!!error}
                  helperText={error?.message}
                  onChange={(eValue) => {
                    const value = eValue.toString();
                    field.onChange(value === "" ? "" : parseFloat(value));
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={7}>
            <FieldTitle title="days from Date Started" />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FieldTitle title="Maximum Time on Hold" />
          </Grid>
          <Grid item xs={2}>
            <Controller
              name="max_onhold_days"
              control={control}
              //>0
              rules={{
                required: "Minimum amount is required", // 添加必填验证
                validate: (value) => {
                  return (
                    parseFloat(value) >= 15 || "Min amount must be at least 15"
                  );
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <CustomProductIntTextField
                  {...field}
                  small
                  error={!!error}
                  helperText={error?.message}
                  onChange={(eValue) => {
                    const value = eValue.toString();
                    field.onChange(value === "" ? "" : parseFloat(value));
                  }}
                  sx={{ marginTop: "12px" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={7}>
            <FieldTitle title="days from Date Submitted" />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FieldTitle title="Maximum Review Period" />
          </Grid>
          <Grid item xs={2}>
            <Controller
              name="underwriting_period_days"
              control={control}
              //>0
              rules={{
                required: "Minimum amount is required", // 添加必填验证
                validate: (value) => {
                  return (
                    parseFloat(value) >= 1 || "Min amount must be at least 1"
                  );
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <CustomProductIntTextField
                  {...field}
                  small
                  error={!!error}
                  helperText={error?.message}
                  onChange={(eValue) => {
                    const value = eValue.toString();
                    field.onChange(value === "" ? "" : parseFloat(value));
                  }}
                  sx={{ marginTop: "12px" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={7}>
            <FieldTitle title="days from Date Submitted" />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FieldTitle title="Offer Expiration" />
          </Grid>
          <Grid item xs={2}>
            <Controller
              name="loanoffer_expiration"
              control={control}
              //>0
              rules={{
                required: "Minimum amount is required", // 添加必填验证
                validate: (value) => {
                  return (
                    //old value >=5, request >=1 hot fix 2026-10-26,becuase some banker need run it on 1 day
                    parseFloat(value) >= 1 || "Min amount must be at least 1"
                  );
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <CustomProductIntTextField
                  {...field}
                  small
                  error={!!error}
                  helperText={error?.message}
                  onChange={(eValue) => {
                    const value = eValue.toString();
                    field.onChange(value === "" ? "" : parseFloat(value));
                  }}
                  sx={{ marginTop: "12px" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={7}>
            <FieldTitle title="days from Counter or Approval Offer Made" />
          </Grid>
        </Grid>
      </Box>
      {/* Form Actions */}
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleSaveClick)}
          disabled={!isDirty || Object.keys(errors).length > 0}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
